export class JardinPMTutoria{    
    idSesion:number;
    nombreSession:string;
    estadoAgenda:string;
    idEstadoAgenda:number;
    fechaAgenda:Date;
    linkZoom:string;
    estadoActa:string;
    idEstadoActa:number;
    
    constructor(){
        this.idSesion = 0;
        this.nombreSession = "";
        this.estadoAgenda = "";
        this.idEstadoAgenda = 0;
        this.fechaAgenda = null;
        this.linkZoom = "";
        this.estadoActa = "";
        this.idEstadoActa = 0;

    }
}
            
export class ResponseJardinPMTutoria{
    payload:JardinPMTutoria[];

    constructor(){
        this.payload = new Array<JardinPMTutoria>();
    }
}
